import React from 'react';

export function IconMenu({ width = 24, height = 24, color = 'currentColor' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        d="M6 7.00073H11C11.2652 7.00073 11.5196 7.10608 11.7071 7.29359C11.8946 7.4811 12 7.73542 12 8.0006C12 8.26578 11.8946 8.5201 11.7071 8.70761C11.5196 8.89512 11.2652 9.00047 11 9.00047H6C5.73478 9.00047 5.48043 8.89512 5.29289 8.70761C5.10536 8.5201 5 8.26578 5 8.0006C5 7.73542 5.10536 7.4811 5.29289 7.29359C5.48043 7.10608 5.73478 7.00073 6 7.00073ZM13 14.9997H18C18.2652 14.9997 18.5196 15.105 18.7071 15.2925C18.8946 15.48 19 15.7343 19 15.9995C19 16.2647 18.8946 16.519 18.7071 16.7065C18.5196 16.8941 18.2652 16.9994 18 16.9994H13C12.7348 16.9994 12.4804 16.8941 12.2929 16.7065C12.1054 16.519 12 16.2647 12 15.9995C12 15.7343 12.1054 15.48 12.2929 15.2925C12.4804 15.105 12.7348 14.9997 13 14.9997Z"
        fill={color}
      />
      <path
        d="M18 11.0002H6C5.73478 11.0002 5.48043 11.1056 5.29289 11.2931C5.10536 11.4806 5 11.7349 5 12.0001C5 12.2653 5.10536 12.5196 5.29289 12.7071C5.48043 12.8946 5.73478 13 6 13H18C18.2652 13 18.5196 12.8946 18.7071 12.7071C18.8946 12.5196 19 12.2653 19 12.0001C19 11.7349 18.8946 11.4806 18.7071 11.2931C18.5196 11.1056 18.2652 11.0002 18 11.0002Z"
        fill={color}
      />
    </svg>
  );
}